import styled from 'styled-components';

export const Small = styled.p`
  margin: 0;
  text-align: left;
  font-size: 12px;
`;
